module.exports = __webpack_public_path__ + "img/sale.47046bb5.png";